/**
 * Docker / Kontejnery — widget-first stránka (2.1).
 * Záložky a panely z module-ui-catalog (sdílené s Node workspace).
 * Na phone layoutu → dedicovaná plocha /phone/containers (MCP-only).
 */
import { Navigate } from 'react-router-dom';
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { useIsPhoneLayout } from '../../lib/ui-layout';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('docker');

export default function DockerPage() {
  const isPhone = useIsPhoneLayout();
  if (isPhone) return <Navigate to='/phone/containers' replace />;
  return <ModuleWorkspace def={DEF} defaultTab='containers' />;
}
